export * from './bed.service';